<div class="table-footer" *ngIf="computedTotalPages > 0">
    <div class="footer-info">
        <span
            >Halaman <strong>{{ currentPage }}</strong> dari
            <strong>{{ computedTotalPages }}</strong></span
        >
    </div>
    <div class="pagination">
        <button
            type="button"
            class="page-btn"
            [disabled]="currentPage <= 1"
            (click)="goToPage(currentPage - 1)"
            aria-label="Halaman sebelumnya"
        >
            <span class="material-icons" aria-hidden="true">chevron_left</span>
            <span>Prev</span>
        </button>
        <div class="page-numbers">
            <button
                *ngFor="let page of paginationRange"
                type="button"
                class="page-num"
                [class.active]="page === currentPage"
                (click)="goToPage(page)"
                [attr.aria-current]="page === currentPage ? 'page' : null"
            >
                {{ page }}
            </button>
        </div>
        <button
            type="button"
            class="page-btn"
            [disabled]="currentPage >= computedTotalPages"
            (click)="goToPage(currentPage + 1)"
            aria-label="Halaman berikutnya"
        >
            <span>Next</span>
            <span class="material-icons" aria-hidden="true">chevron_right</span>
        </button>
    </div>
</div>
